import {
  InputDataInfoType,
  removeNullish,
  useDirectory,
  useSaveDirectoryState,
} from '@atlas-frontend/sdk';
import type { SortingState } from '@tanstack/react-table';
import type { PaginationProps } from 'antd';
import { useMemo } from 'react';

interface UseInputDataDirectoryOptions {
  columns: InputDataInfoType['columns'];
  initialFilters?: Partial<Record<string, any>>;
  initialSort?: SortingState;
  initialPagination?: PaginationProps;
  stateStorageKey: string;
}

export function useInputDataDirectory({
  columns,
  initialFilters,
  initialSort,
  initialPagination,
  stateStorageKey,
}: UseInputDataDirectoryOptions) {
  const queryFilterKeys = useMemo(
    () =>
      columns
        .map((column) => column.code)
        .concat('isInvalid')
        .concat('errorFilterColumns'),
    [columns],
  );
  const directory = useDirectory({
    queryFilterKeys,
    initialFilters,
    initialSort,
    initialPagination,
  });

  useSaveDirectoryState(stateStorageKey, {
    paginationProps: directory.paginationProps,
    queryParameters: directory.queryParameters,
    tableProps: directory.tableProps,
  });

  const { page, size, sort, ...allFilterParams } = directory.queryParameters;
  const filterParams = useMemo(
    () => removeNullish(allFilterParams),
    [allFilterParams],
  );

  return {
    ...directory,
    page,
    size,
    sort,
    filterParams,
  };
}
